import { useEffect, useState } from 'react'

import { getUserProfileInfo, updateUserProfileInfo } from '../../../../../api'
import { useApi, useNotification } from '../../../../../hooks'

export function useUserProfilePageWidgetListInfo({ canView, profileId }) {
  const [info, setInfo] = useState(null)
  const [isInitiated, setInitiated] = useState(false)

  const api = useApi()

  const { handleAddSuccessNotification } = useNotification()

  async function loadInfo({ options }) {
    return getUserProfileInfo({ id: profileId, options })
      .then(response => {
        if (response) {
          setInfo(response.data)

          return response.data
        }

        return null
      })
      .finally(() => {
        setInitiated(true)
      })
  }

  async function updateInfoBlock(
    data,
    successTitle = 'Notification.CommonTitleSavedKey'
  ) {
    return updateUserProfileInfo({ data, id: profileId }).then(
      ({ data: updated }) => {
        setInfo(prevInfo => ({ ...prevInfo, ...updated }))

        if (successTitle) {
          handleAddSuccessNotification(successTitle)
        }

        return updated
      }
    )
  }

  useEffect(() => {
    if (canView && profileId) {
      api.call(loadInfo)
    }

    return () => {
      api.abort()
    }
  }, [canView, profileId])

  return { info, isInitiated, updateInfoBlock }
}
